import InsightsFlexibleFeatureItem from './InsightsFlexibleFeatureItem';

export { useInsightsFlexibleFeatureItem } from './useInsightsFlexibleFeatureItem';
export { type InsightsFlexibleFeatureItemProps } from './InsightsFlexibleFeatureItem';
export default InsightsFlexibleFeatureItem;
